import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFeatureFlagsThunk, getSettingsThunk } from "./redux/actions/misc-actions";

const SetupContainer = () => {
  const dispatch = useDispatch();
  const featureFlagsStatus = useSelector((state) => state.misc.featureFlagsStatus);
  const settingsStatus = useSelector((state) => state.misc.settingsStatus);

  useEffect(() => {
    if (featureFlagsStatus === "initial") {
      dispatch(getFeatureFlagsThunk());
    }
    if (settingsStatus === "initial") {
      dispatch(getSettingsThunk());
    }
  }, []);

  return <></>;
};

export default SetupContainer;
